
$(function () {
  var $kukanSelects = $('.kukanSelects'); // 元のセレクトボックス
  var $kukan1Search = $('#kukan1Search'); // 区間1の格納用のボックス
  var $kukan2Search = $('#kukan2Search'); // 区間2の格納用のボックス

  var $kukanSelectsRemove = $kukanSelects.remove(); // 元のセレクトボックスを消す
  var $kukan1Selects = $kukanSelectsRemove.clone(); // 元のセレクトボックスを複製
  var $kukan2Selects = $kukanSelectsRemove.clone(); // 元のセレクトボックスを複製
  $kukan1Selects.find('.busstopSelect').attr('data-kukan', 'kukan1'); // バス停のセレクトボックスにdata-kukanを付与
  $kukan2Selects.find('.busstopSelect').attr('data-kukan', 'kukan2'); // バス停のセレクトボックスにdata-kukanを付与
  $kukan1Selects.appendTo($kukan1Search); // 区間1の格納用のボックスに入れる
  $kukan2Selects.appendTo($kukan2Search); // 区間2の格納用のボックスに入れる

  var $kukanSelects = $('.kukanSelects'); // 元のセレクトボックスを上書き
  $kukanSelects.each(function () {
    var $routeSelect = $(this).find('.routeSelect'); // 路線のセレクトボックスを取得
    var $busstopSelect = $(this).find('.busstopSelect'); // バス停のセレクトボックスを取得
    var $insertButton = $(this).find('.insertButton'); // 挿入ボタンを取得
    var $closeButton = $(this).find('.closeButton'); // 閉じるボタンを取得

    // バス停を消す関数の実行
    deleteBusstopOptions($routeSelect, $busstopSelect);
    $routeSelect.on('change', function () {
      deleteBusstopOptions($(this), $busstopSelect);
    });

    // 挿入ボタンで挿入
    $insertButton.on('click', function () {
      var busstopName = $busstopSelect.val();
      var kukan = $busstopSelect.attr('data-kukan');
      $('#' + kukan).val(busstopName);
    });
    // 閉じるボタンで閉じる
    $closeButton.on('click', function () {
      var $box = $(this).parent().parent().parent();
      $box.slideUp(100);
      $box.removeClass('is-open');
      $box.addClass('is-close');
    });
  });

  $('.kukanSearchButton').each(function () {
    $(this).on('click', function () {
      var $openTarget = $($(this).attr('data-target'));
      if ($openTarget.hasClass('is-close')) {
        $openTarget.slideDown(100);
        $openTarget.removeClass('is-close');
        $openTarget.addClass('is-open');
      } else {
        $openTarget.slideUp(100);
        $openTarget.removeClass('is-open');
        $openTarget.addClass('is-close');
      }
    });
  });
});

/* =========== バス停を消すの関数 =========== */
function deleteBusstopOptions ($select, $targetSelect) {
  var selectValue = $select.find('option:selected').val(); // 選択されたoptionのvalueを取得
  var $options = $targetSelect.find('option'); // ターゲットのoptionを取得

  if (selectValue != '') {
    // 選択されたoptionのvalueがターゲットのclassと同じだった時の処理
    $options.each(function () {
      var cls = $(this).attr('class');
      var flag = false;
      var clsArray = String(cls).split(' ');
      for (var i = 0, l = clsArray.length; i < l; i++) {
        if (clsArray[i] == selectValue) {
          flag = true;
          break;
        }
      }

      if (flag || cls == undefined) {
        if ($(this).parent().get(0).tagName == 'SPAN') {
          $(this).unwrap();
        }
      } else {
        if ($(this).parent().get(0).tagName == 'SELECT') {
          $(this).wrap('<span style ="display: none">');
        }
      }
    });
  } else {
    // 選択されたoptionのvalueがない時
    $options.each(function () {
      if ($(this).parent().get(0).tagName == 'SPAN') {
        $(this).unwrap();
      }
    });
  }
}
